var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "link-directory container" }, [
    _c(
      "ul",
      { staticClass: "link-directory__quick-links" },
      _vm._l(_vm.schema.settings.linkList, function(link, index) {
        return _c(
          "li",
          { key: index, staticClass: "link-directory__quick-link" },
          [
            link.linkList.length !== 0
              ? _c(
                  "a",
                  {
                    staticClass: "h4 link link--primary",
                    attrs: { href: "#" + link.title + "_links" }
                  },
                  [_vm._v(_vm._s(link.title))]
                )
              : _c(
                  "span",
                  { staticClass: "h4 link link--primary link--disabled" },
                  [_vm._v(_vm._s(link.title))]
                )
          ]
        )
      }),
      0
    ),
    _c(
      "ul",
      { staticClass: "link-directory__category-lists" },
      _vm._l(_vm.schema.settings.linkList, function(link, index) {
        return link.linkList.length !== 0
          ? _c(
              "li",
              {
                key: index,
                staticClass: "link-directory__category-list",
                attrs: { id: link.title + "_links" }
              },
              [
                _c("h2", { staticClass: "h3 link-directory__category-title" }, [
                  _vm._v(_vm._s(link.title))
                ]),
                _c(
                  "ul",
                  { staticClass: "link-directory__category-links" },
                  _vm._l(link.linkList, function(childLink, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "link-directory__category-link"
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "link link--primary",
                            attrs: { href: childLink.url }
                          },
                          [_vm._v(_vm._s(childLink.title))]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          : _vm._e()
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }